export default __webpack_public_path__ + "static/media/winner-prize.4397da02.png";